export default __webpack_public_path__ + "static/media/05_o_preview_1.cdd6984e.jpg";